/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const checkoutScheduledReplenishment = {
  checkoutScheduledReplenishment: {
    autoReplenishOrder: 'Orden de reabastecimiento automático',
    orderType_PLACE_ORDER: 'Ninguno (pedido de una sola vez)',
    orderType_SCHEDULE_REPLENISHMENT_ORDER: 'Orden de reabastecimiento',
    every: 'Cada',
    recurrencePeriodType_DAILY: 'Día(s)',
    recurrencePeriodType_WEEKLY: 'Semana(s)',
    recurrencePeriodType_MONTHLY: 'Mes',
    dayOfMonth: 'Día del mes',
    dayOfMes: 'En el día',
    startOn: 'Empieza en',
    repeatOnDays: 'Repetir en los días siguientes',
    daysOfWeek: {
      MONDAY: 'Lunes',
      TUESDAY: 'Martes',
      WEDNESDAY: 'Miércoles',
      THURSDAY: 'Jueves',
      FRIDAY: 'Viernes',
      SATURDAY: 'Sábado',
      SUNDAY: 'Domingo',
    }
  },
};
